import { defineMessages } from 'react-intl';

export default defineMessages({
  home: {
    id: 'service.home',
    defaultMessage: 'Home',
  },
  serviceTitle: {
    id: 'service.title',
    defaultMessage: 'Service',
  },
  archive: {
    id: 'service.archive',
    defaultMessage: 'Archive',
  },
  mandatoryField: {
    id: 'service.mandatoryField',
    defaultMessage: '(*) Mandatory Field',
  },
  createTitle: {
    id: 'service.create',
    defaultMessage: 'Add New Service',
  },
  editTitle: {
    id: 'service.edit',
    defaultMessage: 'Edit Service',
  },
  createForm: {
    id: 'service.createForm',
    defaultMessage: 'Create New Form',
  },
  formTitle: {
    id: 'service.form.title',
    defaultMessage: 'Add New Form',
  },
  status: {
    active: {
      id: 'service.status.active',
      defaultMessage: 'Active',
    },
    inactive: {
      id: 'service.status.inactive',
      defaultMessage: 'Inactive',
    },
  },
  confirmation: {
    title: {
      id: 'service.confirmation.title',
      defaultMessage: 'Confirmation',
    },
    maintenanceTitle: {
      id: 'service.confirmation.maintenanceTitle',
      defaultMessage: 'Message for Maintenance Page',
    },
    preview: {
      id: 'service.confirmation.preview.title',
      defaultMessage: 'Preview Banner',
    },
    status: {
      id: 'service.confirmation.status',
      defaultMessage: 'Are you sure want to change the status to {status}?',
    },
    archive: {
      id: 'service.confirmation.archive',
      defaultMessage: 'Are you sure want to {status} this service ?',
    },
    extra: {
      archive: {
        id: 'service.confirmation.extra.archive',
        defaultMessage:
          'All billers under this service will be archived and set to default status',
      },
    },
    delete: {
      id: 'service.confirmation.delete',
      defaultMessage: 'Are you sure want to delete {banner} ?',
    },
    message: {
      archive: {
        id: 'service.confirmation.message.archive',
        defaultMessage: 'This service has been archived',
      },
      inactive: {
        id: 'service.confirmation.message.inactive',
        defaultMessage: 'This service has been set to inactive',
      },
      update: {
        id: 'service.confirmation.message.update',
        defaultMessage: 'This service has been updated',
      },
    },
  },
  btn: {
    save: {
      id: 'service.btn.save',
      defaultMessage: 'Save',
    },
    cancel: {
      id: 'service.btn.cancel',
      defaultMessage: 'Cancel',
    },
    change: {
      id: 'service.btn.change',
      defaultMessage: 'Change',
    },
    archive: {
      id: 'service.btn.archive',
      defaultMessage: 'Archive',
    },
    restore: {
      id: 'service.btn.restore',
      defaultMessage: 'Restore',
    },
    delete: {
      id: 'service.btn.delete',
      defaultMessage: 'Delete',
    },
  },
  label: {
    serviceId: {
      id: 'service.label.serviceId',
      defaultMessage: 'Service ID',
    },
    serviceName: {
      id: 'service.label.serviceName',
      defaultMessage: 'Service Name',
    },
    publicServiceName: {
      id: 'service.label.publicServiceName',
      defaultMessage: 'Service Name in Skywalker',
    },
    transactionFee: {
      id: 'service.label.transactionFee',
      defaultMessage: 'Transaction Fee',
    },
    serviceIcon: {
      id: 'service.label.serviceIcon',
      defaultMessage: 'Service Icon',
    },
    serviceBanner: {
      id: 'service.label.serviceBanner',
      defaultMessage: 'Service Banner',
    },
    serviceCategory: {
      id: 'service.label.serviceCategory',
      defaultMessage: 'Service Category',
    },
    status: {
      id: 'service.label.status',
      defaultMessage: 'Status',
    },
    defaultForm: {
      id: 'service.label.defaultForm',
      defaultMessage: 'Default Form',
    },
    aggregator: {
      id: 'service.label.aggregator',
      defaultMessage: 'Aggregator',
    },
    createdat: {
      id: 'service.label.createdat',
      defaultMessage: 'Created At',
    },
    updatedat: {
      id: 'service.label.updatedat',
      defaultMessage: 'Updated At',
    },
  },
  placeholder: {
    serviceName: {
      id: 'service.placeholder.serviceName',
      defaultMessage: 'Enter Service Name',
    },
    publicServiceName: {
      id: 'service.placeholder.publicServiceName',
      defaultMessage: 'Enter Service Name in Skywalker',
    },
    transactionFee: {
      id: 'service.placeholder.transactionFee',
      defaultMessage: 'ex. 2.000 (in IDR)',
    },
    defaultForm: {
      id: 'service.placeholder.defaultForm',
      defaultMessage: 'Search Default Form',
    },
    aggregator: {
      id: 'service.placeholder.aggregator',
      defaultMessage: 'Search Aggregator',
    },
    serviceCategory: {
      id: 'service.placeholder.serviceCategory',
      defaultMessage: 'Choose Service Category',
    },
  },
  error: {
    serviceName: {
      id: 'service.error.serviceName',
      defaultMessage: 'Please input service name',
      length: {
        id: 'service.error.serviceName.length',
        defaultMessage: 'Maksimal 30 character',
      },
    },
    publicServiceName: {
      id: 'service.error.publicServiceName',
      defaultMessage: 'Please input public service name',
      length: {
        id: 'service.error.publicServiceName.length',
        defaultMessage: 'Maksimal 30 character',
      },
    },
    transactionFee: {
      id: 'service.error.transactionFee',
      defaultMessage: 'Please input transaction fee',
      maxFee: {
        id: 'service.error.transactionFee.maxFee',
        defaultMessage: 'Maksimal Rp. 50.000',
      },
    },
    universalKey: {
      id: 'service.error.universalKey',
      defaultMessage: 'PPlease input universal keyword',
      length: {
        id: 'service.error.serviceName.length',
        defaultMessage: 'Maksimal 30 character',
      },
      pattern: {
        id: 'service.error.universalKeyPattern',
        defaultMessage: 'Invalid format! e.g. E_COMMERCE',
      },
    },
    serviceIcon: {
      id: 'service.error.serviceIcon',
      defaultMessage: 'Please upload an icon',
    },
    serviceBanner: {
      id: 'service.error.serviceBanner',
      defaultMessage: 'Please upload a banner',
    },
    defaultForm: {
      id: 'service.error.defaultForm',
      defaultMessage: 'Please choose default form',
    },
    aggregator: {
      id: 'service.error.aggregator',
      defaultMessage: 'Please choose aggregator',
    },
    serviceCategory: {
      id: 'service.error.serviceCategory',
      defaultMessage: 'Please select a Category',
    },
    imageType: {
      id: 'service.error.imageType',
      defaultMessage: 'You can only upload PNG file!',
    },
    imageSize: {
      id: 'service.error.imageSize',
      defaultMessage: 'Image must smaller than {size}KB!',
    },
  },
  extra: {
    archive: {
      id: 'service.extra.archive',
      defaultMessage:
        'By archiving this service is considered no longer active',
    },
    serviceIcon: {
      id: 'service.extra.serviceIcon',
      defaultMessage:
        'File format only .png with resolution 64px x 64px and maximum size of 50kb',
    },
    serviceBanner: {
      id: 'service.extra.serviceBanner',
      defaultMessage:
        'File format only .png with resolution 375px x 96px and maximum size of 100kb',
    },
  },
});
